import React from 'react';
import ErrorFormAlertView from "../../../../Common/ErrorFormAlertView";
import {RootState} from "../../../../../../reducers";
import {connect} from "react-redux";
import {useTranslation, withTranslation} from "react-i18next";
import {getCart} from "../../../../../services/Cart/reducer";
import {ReactComponent as EditSVG} from "../../../../../../images/icons/edit.svg";
import {ReactComponent as BarcodeSVG} from "../../../../../../images/icons/barcode.svg";

interface OwnProps {
    setRoomNumberModal: React.Dispatch<React.SetStateAction<boolean>>;
    errors: any[];
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps

const CartPageRoomServiceSection = ({cart, setRoomNumberModal, errors}: Props) => {
    const {t} = useTranslation();

    return (
        <div className="card-cart">
            <div className={"container-fluid"}>
                <h5 className={"card-cart-header"}>
                    {t("enums.order.type.ROOM_SERVICE")}
                    <small>
                        {t("modules.cart.field.scan_room_qr_code.title")}
                    </small>
                </h5>
                <ErrorFormAlertView field={"number"} errors={errors}/>
                <div className={"card-cart-body"}>
                    <button className={"btn btn-outline-primary w-100 btn-lg"}
                            onClick={() => setRoomNumberModal(true)}>
                        {cart.number ? (
                            <>
                                {`${t("modules.cart.field.room_nr.title", {number: cart.number})} `}
                                <EditSVG/>
                            </>
                        ) : (
                            <>
                                {`${t("modules.cart.action.scan_table_qr_code.title")} `}
                                <BarcodeSVG/>
                            </>
                        )}
                    </button>
                </div>
            </div>
        </div>
    )
}
const mapStateToProps = (state: RootState) => ({
    cart: getCart(state.cart)
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartPageRoomServiceSection));
